/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminPalletOrderList
 */
export interface AdminPalletOrderList {
    /**
     * 
     * @type {number}
     * @memberof AdminPalletOrderList
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPalletOrderList
     */
    items: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPalletOrderList
     */
    junkItems: number;
    /**
     * 
     * @type {string}
     * @memberof AdminPalletOrderList
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPalletOrderList
     */
    orderDate: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPalletOrderList
     */
    orderLink: string;
    /**
     * 
     * @type {number}
     * @memberof AdminPalletOrderList
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPalletOrderList
     */
    productItems: number;
}

export function AdminPalletOrderListFromJSON(json: any): AdminPalletOrderList {
    return AdminPalletOrderListFromJSONTyped(json, false);
}

export function AdminPalletOrderListFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPalletOrderList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'items': json['items'],
        'junkItems': json['junkItems'],
        'name': json['name'],
        'orderDate': json['orderDate'],
        'orderLink': json['orderLink'],
        'price': json['price'],
        'productItems': json['productItems'],
    };
}

export function AdminPalletOrderListToJSON(value?: AdminPalletOrderList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'items': value.items,
        'junkItems': value.junkItems,
        'name': value.name,
        'orderDate': value.orderDate,
        'orderLink': value.orderLink,
        'price': value.price,
        'productItems': value.productItems,
    };
}

